import React from 'react'
import { TextValidator } from '@/housefolios-components/shared/muiFormValidator'
import { InputAdornment, IconButton } from '@mui/material'
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import { VALIDATION_RULES } from '@/constants/validation'

const PasswordInput = ({
  password,
  setPassword,
  passwordMask,
  setPasswordMask,
}) => {
  return (
    <TextValidator
      fullWidth={true}
      variant="outlined"
      label="Password"
      value={password}
      onChange={(event) => setPassword(event.target.value)}
      type={passwordMask ? 'password' : 'text'}
      validators={VALIDATION_RULES.password.validators}
      errorMessages={VALIDATION_RULES.password.errorMessages}
        slotProps={{
          input: {
            endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={() => setPasswordMask(!passwordMask)}
              size="large"
            >
              {passwordMask ? (
                <RemoveRedEyeIcon />
              ) : (
                <VisibilityOffIcon />
              )}
            </IconButton>
          </InputAdornment>
        ),
          },
        }}
      />
  )
}

export default PasswordInput
